import { Button } from "@mui/material";
import { ColorsConstants } from "../cssUtils/constants";
import typography from "../cssUtils/typography";

const HeightButton = ({
  onClick,
  title,
  children,
  startIcon = null,
  endIcon = null,
  disabled = false,
  variant = "contained",
  sx,
  ...props
}) => {
  const isOutlined = variant === "outlined";

  return (
    <Button
      variant={variant}
      size="medium"
      disableElevation
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      sx={{
        // Apply typography
        ...typography.bodyLarge,
        
        // Conditional styles based on variant
        ...(isOutlined
          ? {
              backgroundColor: "transparent",
              color: ColorsConstants.primaryBlue100,
              border: `1px solid ${ColorsConstants.primaryBlue100}`,
              "&:hover": {
                backgroundColor: "#F3F4F6",
                border: `1px solid ${ColorsConstants.primaryBlue100}`,
              },
              "&.Mui-disabled": {
                border: `1px solid ${ColorsConstants.primaryBlue80}`,
                color: ColorsConstants.primaryBlue100,
              },
            }
          : {
              backgroundColor: ColorsConstants.primaryBlue100,
              color: "white",
              "&:hover": {
                backgroundColor: ColorsConstants.primaryBlue100,
              },
              "&.Mui-disabled": {
                backgroundColor: ColorsConstants.primaryBlue80,
                color: "white",
              },
            }),

        // Common styles
        boxShadow: "none",
        "&:active": { boxShadow: "none" },
        "&:focus": { boxShadow: "none" },
        borderRadius: 2,
        height: 53,
        textTransform: "capitalize",
        
        // Custom styles
        ...sx,
      }}
      {...props}
    >
      {children ?? title}
    </Button>
  );
};

export default HeightButton;